import { useState } from "react";
import { Button, Box, Container, Divider, Grid, List, Typography } from "@mui/material";

import { logAnalyticsEvent } from 'lib/firebase/analytics';
import Layout from "lib/components/Layout";

import { base } from "themes";
import { Logo } from 'components/icons';
import { FOOTER_PROPS } from "constants";

import { useData } from "hooks";
import { BuylistItem } from "./BuylistItem";
import { CardPreview } from "./CardPreview";


export default function Buylist() {
  const [buyer,] = useState({
    name: "Agustin",
    phone: "971505246532",
  });
  const [buylist,] = useData(`tcgist/buylist`);
  const [preview, setPreview] = useState({});

  const listing = buylist?.map((item, index) => (
    <BuylistItem
      buyer={buyer}
      item={item}
      key={`index-${index}`}
      onMouseEnter={() => setPreview(item)}
    />
  ));

  return (
    <Layout
      theme={base}
      footerProps={FOOTER_PROPS}
      navbarProps={{
        logo: (<Logo />),
        right: (
          <Button
            href="https://szk4u.mjt.lu/wgt/szk4u/xu59/form?c=0799e44b"
            target="_blank"
            variant="contained"
            onClick={() => logAnalyticsEvent('click', { label: 'Try TCGist' })}
          >
            Try TCGist
          </Button>
        )
      }}
    >
      <Container sx={{ pt: 14, height: "80%" }}>
        <Typography gutterBottom variant="h5">
          {buyer.name}'s buylist
        </Typography>

        <Typography gutterBottom variant="body1">
          {`This list has ${buylist?.length} individual items`}
        </Typography>

        <Typography gutterBottom variant="body1">
          {`This list has ${buylist?.reduce((n, {quantity}) => n + quantity, 0)} items in total`}
        </Typography>

        <Divider />

        <Grid container>
          <Grid item sm={2} md={3} sx={{ display: { xs: "none", md: "block" } }}>
            <CardPreview item={preview} />
          </Grid>

          <Grid item xs={12} md={9}>
            <Box sx={{ display: "flex", flexFlow: "column wrap" }}>
              <List sx={{ columnCount: { sm: 1, md: 2, lg: 2, xl: 3 } }}>
                {listing}
              </List>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};
